import { AuthUser } from '~/data/models/user';
import { getCountryFromPhoneCountryCode } from '~/data/utils';
import { RespondSettings } from './types';

// Maps an authenticated user onto the identity respond.io reads from
// window.__respond_settings. The field names and formats follow respond.io's
// documented schema:
// https://respond.io/help/website-chat-widget/website-chat-widget
//   - phone: the full international number, dialing code + local number, with no
//     leading "+" (e.g. "491761234567"). We only have the two parts separately,
//     so join them and drop the national trunk "0" (DE/AT/TR all use it).
//   - countryCode: an ISO alpha-2 code ("DE"), not the dialing code ("49").
//
// Only these public fields are copied — never a credential. In particular
// authUser.externalTokens.intercom (Intercom's identity-verification JWT) must
// never reach respond.io, which verifies nothing it is given.
export function identityFromAuthUser(authUser: AuthUser): RespondSettings {
  const dialCode = (authUser.phoneCountryCode ?? '').replace(/\D/g, '');
  const localNumber = (authUser.phone ?? '')
    .replace(/\D/g, '')
    .replace(/^0/, '');

  const phone = localNumber ? `${dialCode}${localNumber}` : '';
  const countryCode =
    phone && dialCode ? getCountryFromPhoneCountryCode(dialCode) : '';

  return {
    identifier: authUser.email,
    email: authUser.email,
    firstName: authUser.firstName,
    lastName: authUser.lastName,
    phone,
    countryCode,
  };
}
